"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 15px 0;\n  max-width: 100%;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 95%;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 95%;\n  border-top: solid 1px ", ";\n  position: relative;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  width: 10%;\n\n  /* Thank you, IE, and the horse you rode in on */\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    padding-bottom: 160%;\n    height: 1px;\n    overflow: visible;\n    display: block;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-height: 16px;\n  max-width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  display: block;\n  right: 0;\n  transform: translate(90%, -50%);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  stroke: ", ";\n  fill: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IconOffPath = _styledComponents.default.path(_templateObject(), function (props) {
  return props.theme.colorNeutralLight;
}, function (props) {
  return props.theme.colorNeutralLight;
});

var IconOnPath = _styledComponents.default.path(_templateObject2(), function (props) {
  return props.theme.colorPrimaryDark;
}, function (props) {
  return props.theme.colorPrimaryDark;
});

var IconRangePath = _styledComponents.default.path(_templateObject3(), function (props) {
  return props.theme.colorPrimary;
}, function (props) {
  return props.theme.colorPrimary;
});

var IconRowBreakCountSpan = _styledComponents.default.span(_templateObject4());

var IconRowBreakCountSvg = _styledComponents.default.svg(_templateObject5());

var IconSpan = _styledComponents.default.span(_templateObject6());

var RowBreakDiv = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.theme.colorBorder;
});

var IconSvg = _styledComponents.default.svg(_templateObject8());

var RowIconDiv = _styledComponents.default.div(_templateObject9());

var IconArrayDiv = _styledComponents.default.div(_templateObject10());

function IconWrapper(props) {
  return _react.default.createElement(IconSpan, {
    className: "hw-array-".concat(props.iconStyle),
    key: props.id
  }, _react.default.createElement(IconSvg, {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 80",
    preserveAspectRatio: "xMidYMin slice",
    focusable: "false"
  }, props.children));
}

IconWrapper.propTypes = {
  iconStyle: _propTypes.default.string,
  id: _propTypes.default.string,
  children: _propTypes.default.node.isRequired
};
IconWrapper.defaultProps = {
  iconStyle: 'icon_off',
  theme: _Theme.defaultTheme
};

var IconArray = /*#__PURE__*/function (_Component) {
  _inherits(IconArray, _Component);

  function IconArray() {
    _classCallCheck(this, IconArray);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconArray).apply(this, arguments));
  }

  _createClass(IconArray, [{
    key: "getCountMarker",
    value: function getCountMarker(keyBase) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _react.default.createElement(IconRowBreakCountSpan, {
        className: 'hw-icon-break-row-count',
        key: "count-marker-".concat(keyBase, "-").concat(count)
      }, _react.default.createElement(IconRowBreakCountSvg, {
        role: "presentation",
        width: "42",
        height: "26",
        viewBox: "0 0 42 26",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false"
      }, _react.default.createElement("g", null, _react.default.createElement("text", {
        transform: "matrix(1.6493341922760008,0,0,1.6493341922760008,-0.23193762078881264,-0.11160431429743767) ",
        stroke: "null",
        y: "12.49819",
        x: "0.55858",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontSize: "12"
      }, count))));
    }
  }, {
    key: "getSvgPart",
    value: function getSvgPart(style, otherAttributes) {
      var as = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'path';

      switch (style) {
        case 'icon_on':
          return _react.default.createElement(IconOnPath, _extends({
            as: as
          }, otherAttributes, {
            theme: this.props.theme
          }));

        case 'icon_range':
          return _react.default.createElement(IconRangePath, _extends({
            as: as
          }, otherAttributes, {
            theme: this.props.theme
          }));

        default:
          return _react.default.createElement(IconOffPath, _extends({
            as: as
          }, otherAttributes, {
            theme: this.props.theme
          }));
      }
    }
  }, {
    key: "getNeutralIcon",
    value: function getNeutralIcon(key) {
      var iconStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon_off';
      return _react.default.createElement(IconWrapper, {
        key: key,
        id: key,
        iconStyle: iconStyle,
        theme: this.props.theme
      }, _react.default.createElement("g", null, this.getSvgPart(iconStyle, {
        strokeWidth: '3',
        d: 'm40.50356,32.83198l-15.50356,47.16802l-15.50356,-47.16802l31.00712,0z'
      }), this.getSvgPart(iconStyle, {
        strokeWidth: '3',
        cy: '20.5',
        cx: '25',
        r: '9.0625'
      }, 'circle')));
    }
  }, {
    key: "getFemaleIcon",
    value: function getFemaleIcon(key) {
      var iconStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon_off';
      return _react.default.createElement(IconWrapper, {
        key: key,
        id: key,
        iconStyle: iconStyle,
        theme: this.props.theme
      }, _react.default.createElement("g", null, this.getSvgPart(iconStyle, {
        strokeWidth: '1',
        cy: '15.99642',
        cx: '25',
        r: '7.49054'
      }, 'circle'), this.getSvgPart(iconStyle, {
        d: 'm24.9478,22.25514c3.53531,0 6.40466,-2.46273 6.40466,-5.50086c0,-3.03984 -2.86934,-5.50428 -6.40466,-5.50428c-3.5383,0 -6.40863,2.46444 -6.40863,5.50428c0,3.03813 2.86934,5.50086 6.40863,5.50086zm17.96242,23.72371l-5.74762,-18.30894c-0.0536,-0.16623 -0.12903,-0.32478 -0.22033,-0.47141c-0.65308,-1.71513 -2.52792,-2.95715 -4.74221,-2.95715l-14.54719,0c-2.30858,0 -4.24696,1.34858 -4.81764,3.17879c-0.03871,0.08013 -0.07047,0.16452 -0.09925,0.25147l-5.64539,18.30809c-0.37617,1.20025 0.45357,2.43374 1.853,2.75683c1.39746,0.32137 2.83362,-0.39128 3.20979,-1.59152l4.43353,-14.3817l1.84706,0l-8.04627,26.02106l7.58179,0l0,17.96455c0,1.38182 1.30217,2.50109 2.91301,2.50109c1.60687,0 2.91202,-1.11842 2.91202,-2.50109l0,-17.96455l2.31652,0l0,17.96455c0,1.38182 1.30415,2.50109 2.915,2.50109c1.60687,0 2.91202,-1.11842 2.91202,-2.50109l0,-17.96455l7.5778,0l-8.07604,-26.02106l1.89569,0l4.51491,14.3817c0.37616,1.20025 1.81233,1.91289 3.20977,1.59152c1.39448,-0.32308 2.22421,-1.55743 1.85004,-2.75768l0,0z',
        fillOpacity: 'null',
        strokeOpacity: 'null',
        strokeWidth: '1',
        stroke: 'null',
        fill: 'null'
      })));
    }
  }, {
    key: "getMaleIcon",
    value: function getMaleIcon(key) {
      var iconStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'icon_off';
      return _react.default.createElement(IconWrapper, {
        key: key,
        id: key,
        iconStyle: iconStyle,
        theme: this.props.theme
      }, _react.default.createElement("g", null, this.getSvgPart(iconStyle, {
        strokeWidth: '1.53',
        d: 'm43.48424,33.63831l0,-2.74599c0,-2.88918 -3.36696,-5.23169 -7.52503,-5.23169l-21.92206,0c-4.15567,0 -7.52503,2.34251 -7.52503,5.23169l0,2.74599c-0.00727,0.06233 -0.01212,0.12635 -0.01212,0.1912l0,15.81639c0,1.22895 1.43208,2.22458 3.19975,2.22458c1.76525,0 3.20095,-0.99563 3.20095,-2.22458l0,-15.58222l2.14568,0l0,17.80848l0.01575,0l0,25.16285c0,1.6358 1.91065,2.96499 4.26592,2.96499c2.35649,0 4.26592,-1.3275 4.26592,-2.96499l0,-25.16285l2.81447,0l0,25.16285c0,1.6358 1.91183,2.96499 4.26592,2.96499c2.35648,0 4.26591,-1.3275 4.26591,-2.96499l0,-25.16285l0.01333,0l0,-17.80848l2.14568,0l0,15.58137c0,1.22896 1.4357,2.22543 3.20096,2.22543c1.76769,0 3.19975,-0.99647 3.19975,-2.22543l0,-15.81638c-0.0012,-0.0657 -0.0085,-0.12804 -0.01575,-0.19037l0,0l0,0.00001z'
      }), this.getSvgPart(iconStyle, {
        strokeWidth: '1.5',
        cy: '15.99642',
        cx: '25',
        r: '7.49054'
      }, 'circle')));
    }
  }, {
    key: "getRowBreak",
    value: function getRowBreak(keyBase, count) {
      return _react.default.createElement(RowBreakDiv, {
        key: "row-break-".concat(keyBase, "-").concat(count)
      }, this.getCountMarker(keyBase, count));
    }
  }, {
    key: "getIconRow",
    value: function getIconRow(keyBase, icons, count) {
      return _react.default.createElement(RowIconDiv, {
        key: "row-".concat(keyBase, "-").concat(count)
      }, icons);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var getIconFactory = {
        neutral: function neutral(key, style) {
          return _this.getNeutralIcon(key, style);
        },
        female: function female(key, style) {
          return _this.getFemaleIcon(key, style);
        },
        male: function male(key, style) {
          return _this.getMaleIcon(key, style);
        }
      };
      var iconStyles = {
        on: 'icon_on',
        off: 'icon_off',
        midRange: 'icon_range'
      };
      var _this$props = this.props,
          minRange = _this$props.minRange,
          maxRange = _this$props.maxRange,
          total = _this$props.total,
          iconType = _this$props.iconType,
          forceBreakOn = _this$props.forceBreakOn;
      minRange = parseInt(minRange, 10);
      maxRange = parseInt(maxRange, 10) || 0;
      total = parseInt(total, 10);
      var getIcon = getIconFactory[iconType];
      var keyBase = "icon-array-key-".concat(Math.ceil(Math.random() * 99999999));
      var rows = [this.getRowBreak(keyBase, 0)];
      var icons = [];

      for (var count = 1; count <= total; count++) {
        var iconStyle = iconStyles.off;

        if (count <= minRange) {
          iconStyle = iconStyles.on;
        } else if (count <= maxRange) {
          iconStyle = iconStyles.midRange;
        }

        icons.push(getIcon("".concat(keyBase, "-").concat(count), iconStyle));

        if (count % forceBreakOn === 0) {
          rows.unshift(this.getIconRow(keyBase, icons, count));
          rows.unshift(this.getRowBreak(keyBase, count));
          icons = [];
        }
      }

      if (icons.length !== 0) {
        rows.unshift(this.getIconRow(keyBase, icons, total));
        rows.unshift(this.getRowBreak(keyBase, total));
      }

      return _react.default.createElement(IconArrayDiv, {
        "aria-hidden": true
      }, rows);
    }
  }]);

  return IconArray;
}(_react.Component);

IconArray.propTypes = {
  minRange: _propTypes.default.string,
  maxRange: _propTypes.default.string,
  total: _propTypes.default.string,
  iconType: _propTypes.default.oneOf(['male', 'female', 'neutral']),
  forceBreakOn: _propTypes.default.number,
  theme: _propTypes.default.shape({
    colorNeutralLight: _propTypes.default.string,
    colorPrimaryDark: _propTypes.default.string,
    colorPrimary: _propTypes.default.string,
    colorBorder: _propTypes.default.string
  })
};
IconArray.defaultProps = {
  minRange: '0',
  total: '100',
  iconType: 'neutral',
  forceBreakOn: 10,
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(IconArray);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/IconArray/index.js